import template from "./log_time_employee.html";
import * as Utils from "../../lib/savanna_utils.js";
import tr from '../../lib/default-translator.js';
import * as Navbar from '../../lib/update_navbar_notifications.js';

class LogTimeEmployeeViewModel
{
	constructor(dialog)
	{
		this.dialog = dialog;

		//edit mode
		this.task_time_id = ko.observable();
		this.users = ko.observableArray([]);
		this.available_users = ko.observableArray([]);
		this.selected_user = ko.observable();
		this.approval_route = ko.observableArray();

		//the rest
		this.project_name = ko.observable();
		this.task_id = ko.observable();
		this.projects = ko.observableArray();
		this.description = ko.observable();
		this.start_time = ko.observable();
		this.end_time = ko.observable();
		this.rejection_reason = ko.observable();
		this.total_hours = ko.observable(0);
		this.from_filter = ko.observable(Utils.toJSONDateString(new Date()));
		this.to_filter = ko.observable(Utils.toJSONDateString(new Date()));
		this.tasks_logged = ko.observableArray();
		this.view_only = ko.observable(false);
		this.select_individual = ko.observable(false);
		this.company_id = ko.observable();
		this.transaction_types = ko.observableArray();
		this.transaction_type_id = ko.observable();
		this.selected_employee = ko.observable(false);

		//lunch stuff
		this.include_lunch = ko.observable(false);
		this.lunch_start = ko.observable();
		this.lunch_end = ko.observable();
		this.resubmit = ko.observable(false);
		this.rejected_id = ko.observable();
		this.today = ko.observable(Utils.toJSONDateString(new Date()));
		this.holidays = ko.observableArray([]);
		this.event_dates = ko.observableArray([]);
		this.start_date_picker = null;
		this.end_date_picker = null;
		this.summary_filter_earned_end = ko.observable(Utils.toJSONDateString(new Date())); // today
		this.leave_summary = ko.observableArray();

		
		this.from_filter.subscribe((d) => {
			if (d > this.to_filter())
				this.to_filter(d);

			this.dialog.updateData();
		})

		this.to_filter.subscribe((d) => {
			if (d < this.from_filter())
				this.from_filter(d);

			this.dialog.updateData();
		})

		this.start_time.subscribe((val) => {
			if (val) {
				let start_date = new Date(val);
				let end_date = new Date(start_date.getTime() + (60 * 60 * 8000)); // Add 8 hours

				this.end_date_picker.set('minDate', val); // Ensure end date can't be before start date
				this.end_time(this.formatting_date(end_date));
				this.end_date_picker.setDate(end_date);
	
			}

			this.validate_and_calculate_hours();
		});

		this.end_time.subscribe((val) => {
			if (val)
				this.validate_and_calculate_hours();
		});

		this.total_hours.subscribe((d) => {
			//if both then total_hours must be set to the difference, it cant be bigger
			if (this.start_time() && this.end_time()) {
				let hours = this.calculate_hours()
				if (d > hours) {
					this.total_hours(hours);
					Grape.alerts.alert(
						{
							type: 'error',
							message: tr('The total hours can not be more than the time difference'),
							title: tr('Error', 'Error')
						}
					);
				}
			}
		})

		this.task_id.subscribe((value) => {
			let selected_project = this.projects().find((project) => project.task_id === value);
			this.transaction_type_id(selected_project?.transaction_type_id || null);
		})

		this.selected_user.subscribe((newValue) => {
			if (newValue) {
				this.load_events();
			}
		});

	}

	reinitialize_datepickers()
	{
		if (this.start_date_picker && this.end_date_picker) {
			this.start_date_picker.destroy();
			this.end_date_picker.destroy();
		}
		this.initialize_datepickers();
	}

	initialize_datepickers(res_requests)
	{
		let calendar_config = {
			enableTime: true,
			dateFormat: "Y-m-d H:i",
			allowInput: true,
			onDayCreate: (dObj, dStr, fp, dayElem) => {
				let date_string = new Date(dayElem.dateObj.getTime() -
					(dayElem.dateObj.getTimezoneOffset() * 60000)).toISOString().split('T')[0];
				
				let event = this.event_dates().find(e => e.date === date_string);
				
				if (event)
				{
					dayElem.classList.add(event.css_class);
					dayElem.style.backgroundColor = event.hexcolor;
					dayElem.setAttribute('title', event.name);
				}

				if (date_string == this.today) 
					dayElem.classList.add('today');
			},
			appendTo: document.body,
			static: true,
			onClose: (selectedDates, dateStr, instance) => {
				// Update the corresponding observable when the datepicker is closed
				if (instance.element.id === 'datepicker_start')
					this.start_time(dateStr);
				else if (instance.element.id === 'datepicker_end')
					this.end_time(dateStr);
			}
		};

		this.start_date_picker = flatpickr('#datepicker_start', {
			...calendar_config,
			defaultDate: this.start_time() || null
		});
		
		this.end_date_picker = flatpickr('#datepicker_end', {
			...calendar_config,
			defaultDate: this.end_time() || null
		});
	}

	async load_events()
	{

		if (!this.selected_user())
		{
			// If no user is selected, clear the events
			this.event_dates([]);
			this.reinitialize_datepickers();
			return;
		}
		
		try
		{
			let res_requests = await Grape.fetches.postJSON('/leave/get_leave_taken_and_requests',
				{ employee_id: this.selected_user() });
			
			if (res_requests.status !== 'ERROR')
			{
				this.parse_leave(res_requests);
				// Reinitialize datepickers with new event data
				this.reinitialize_datepickers();
			}
		}
		catch (error) {
			Grape.alerts.alert(
				{
					type: 'error',
					message: tr('Failed to load leave and holiday data'),
					title: tr('Error')
				}
			);
		}
	}
	
	parse_leave(res)
	{
		let event_dates = [];

		// Parse finalized leave
		if (res.all_finalized_leave && res.all_finalized_leave.length > 0)
			event_dates = event_dates.concat(this.parse_final_leave(res.all_finalized_leave));

		// Parse leave to approve - BUT skip rejected leave requests
		if (res.all_leave_to_approve && res.all_leave_to_approve.length > 0)
		{
			// Filter out rejected leave requests before processing
			let approvedLeaveRequests = res.all_leave_to_approve.filter(leave => leave.approved !== 'rejected');
		
			if (approvedLeaveRequests.length > 0)
			{
				let requestedDates = this.parse_final_dates(approvedLeaveRequests.flatMap(leave => leave.dates_included));
				event_dates = event_dates.concat(requestedDates);
			}
		}

		// Parse holidays (assuming holidays are included in the response)
		if (this.holidays && this.holidays().length > 0) {
			let holiday_dates = this.parse_holidays(this.holidays());
			event_dates = event_dates.concat(holiday_dates);
		}

		this.event_dates(event_dates);
	}
	
	parse_final_leave(finalizedLeave)
	{
		return finalizedLeave.flatMap(leave =>
			leave.dates_included.map(date => ({
				date: date,
				css_class: leave.css_class_name,
				hexcolor: leave.hexcolor,
				name: `${leave.leave_type} (Finalized)`
			}))
		);
	}
	
	parse_final_dates(dateArray)
	{
		return dateArray.map(date => ({
			date: date,
			css_class: 'request_date',
			hexcolor: '#fff3cd',
			name: 'Requested Leave day'
		}));
	}
	
	parse_holidays(holidays)
	{
		return holidays.map(holiday => ({
			date: holiday.holiday_date,
			css_class: holiday.css_class_name,
			hexcolor: holiday.hexcolor,
			name: holiday.description
		}));
	}

	is_same_day(date1, date2)
	{
		return date1.getFullYear() === date2.getFullYear() &&
			date1.getMonth() === date2.getMonth() &&
			date1.getDate() === date2.getDate();
	}

	formatting_date(date)
	{
		return date.getFullYear() + '/' +
			String(date.getMonth() + 1).padStart(2, '0') + '/' +
			String(date.getDate()).padStart(2, '0') + ' ' +
			String(date.getHours()).padStart(2, '0') + ':' +
			String(date.getMinutes()).padStart(2, '0');
	}



	validate_and_calculate_hours()
	{
		if (this.start_time() && this.end_time()) {
			let start = new Date(this.start_time());
			let end = new Date(this.end_time());

			if (end < start) {
				Grape.alerts.alert(
					{
						type: 'warning',
						message: tr('End time cannot be set earlier than start time.'),
						title: tr('Warning', 'Warning')
					}
				);
				
				this.end_time(); // Reset end time
				this.total_hours(0);
			}
			else
				this.total_hours(this.calculate_hours());
		}
	}

	calculate_hours()
	{
		if (!this.start_time() || !this.end_time())
			return;

		let start_time = new Date(this.end_time());
		let end_time = new Date(this.start_time());
		let diff = (end_time.getTime() - start_time.getTime()) / 1000;
		diff /= 60 * 60;

		return Math.abs(Number(diff).toFixed(2));
	}

	close()
	{
		this.dialog.close();
	}

	async save_entry()
	{
		// Initial validations
		if (!this.task_id() && !this.project_name())
		{
			Grape.alerts.alert({type: 'error', message: tr('Please provide either a new task name or select an already existing task name'), title: tr('Error')});
			return;
		}
		if (!this.description())
		{
			Grape.alerts.alert({type: 'error', message: tr('Please add a description'), title: tr('Error')});
			return;
		}
		if (!this.start_time())
		{
			Grape.alerts.alert({type: 'error', message: tr('Please select a valid start time'), title: tr('Error')});
			return;
		}
		if (!this.end_time() || this.end_time() < this.start_time())
		{
			Grape.alerts.alert({type: 'error', message: tr('Please select a valid end time'), title: tr('Error')});
			return;
		}
		if (!this.total_hours() || this.total_hours() < 0)
		{
			Grape.alerts.alert({type: 'error', message: tr('Please select the total number of hours as a positive number'), title: tr('Error')});
			return;
		} 

		if (this.selected_user() === undefined)
		{
			Grape.alerts.alert({ type: 'error', message: tr('Please select an employee to log time for.'), title: tr('Error') });
			return;
		}

		if (Grape.config.public_settings.time_rule_priority)
		{
			console.log('time rules priority is active');
			//fetch time rules for employee_id

			let time_rule_data = {
				schema: 'public',
				table: 'time_rules',
				filter: [{
					field: 'employee_id',
					operand: '=',
					value: this.selected_user()
				}]
			}

			let time_rule_res = await Grape.fetches.getJSON('api/record', time_rule_data);
			console.log('time_rules', time_rule_res)

			if (time_rule_res.records.length >= 1)
			{
				console.log('have time rules setup')
			}
			else
			{
				Grape.alerts.alert({type: 'warning', message: tr('Current employee does not have time rules please add time rules to employee or speak to manager to add time rules to log time.'), title: tr('Warning')});
				return;
			}
		}
	
		// Lunch validation
		if (this.include_lunch())
		{
			if (!this.lunch_start() && !this.lunch_end())
			{
				Grape.alerts.alert({type: 'warning', message: tr('Please enter start and end time for lunch'), title: tr('Warning')});
				return;
			}
			if (!this.lunch_start() )
			{
				Grape.alerts.alert({type: 'warning', message: tr('Please enter a start time for lunch'), title: tr('Warning')});
				return;
			}
			if (!this.lunch_end() )
			{
				Grape.alerts.alert({type: 'warning', message: tr('Please enter a end time for lunch'), title: tr('Warning')});
				return;
			}
			if (this.lunch_start() >= this.lunch_end())
			{
				Grape.alerts.alert({type: 'warning', message: tr('Start time of lunch has to be before  the end time'), title: tr('Warning')});
				return;
			}
		}
	
		// Check for leave/holiday conflicts
		let start_date = new Date(this.start_time());
		let end_date = new Date(this.end_time());
		let formatted_start_date = start_date.toISOString().split('T')[0];
		let formatted_end_date = end_date.toISOString().split('T')[0];
	
		// Check holidays and leave dates
		let holiday = this.holidays().find(h => 
			h.holiday_date === formatted_start_date || h.holiday_date === formatted_end_date
		);
		
		let leave_dates = this.event_dates().filter(e => 
			(e.date === formatted_start_date || e.date === formatted_end_date) && 
			(e.css_class === 'request_date' || e.name.includes('Finalized'))
		);
	
		// Determine the type of date conflict
		let date_status = holiday ? 'HOLIDAY' : leave_dates.length > 0 ? 'LEAVE' : 'no_conflict';
	
		let should_proceed = true;
		
		switch (date_status)
		{
			case 'HOLIDAY': {
				const response = await Grape.alerts.confirm({ 
					message: tr('This is a holiday. Are you sure you want to log this time?'),
					title: tr('Warning'), 
					type: 'warning' 
				});
				should_proceed = response;
				break;
			}
			case 'LEAVE': {
				const response = await Grape.alerts.confirm({ 
					message: tr('This is a leave date. Are you sure you want to log this time?'),
					title: tr('Warning'), 
					type: 'warning' 
				});
				should_proceed = response;
				break;
			}
			case 'no_conflict':
				should_proceed = true;
				break;
		}
	
		if (!should_proceed) return;
	
		// Prepare parameters for saving
		let params = {
			employee_id: this.selected_user(),
			description: this.description(),
			start_time: this.start_time(),
			end_time: this.end_time(),
			total_hours: this.total_hours(),
			project_text: this.project_name(),
			project_id: this.task_id() || null,
			task_time_id: this.task_time_id() || -1,
			rejected_id: this.rejected_id(),
			transaction_type_id: this.transaction_type_id() || null,
			company_id: this.company_id(),
		};
	
		// Add lunch parameters if included
		if (this.include_lunch())
		{
			params.lunch_start = moment(this.start_time().substring(0, 10) + ' ' + this.lunch_start()).format();
			params.lunch_end = moment(this.end_time().substring(0, 10) + ' ' + this.lunch_end()).format();
		}
	
		
		let res = await Grape.fetches.postJSON('/time_management/edit_task_time', params);
		
		switch (res.status)
		{
			case 'OK': {
				let success_message = params.task_time_id === -1 ? tr('Successfully added time log.') : tr('Successfully edited time log.');
					
				await Grape.alerts.alert({
					type: 'success',
					message: success_message,
					title: tr('Success')
				});
				await Navbar.updateTimeToApproveCount();
				this.dialog.close();
				break;
			}
			case 'ERROR': {
				Grape.alerts.apiError(res);
				break;
			}
			default: {
				Grape.alerts.alert({
					type: 'error', 
					message: tr('Something went wrong...'), 
					title: tr('Error')
				});
			}
		}
	}
}

class LogTimeEmployeePage
{
	constructor (bindings)
	{
		this.viewModel = new LogTimeEmployeeViewModel(this);
		this.bindings = bindings;
		this.viewModel.employee_id = bindings.employee_id;
		document.querySelector('.ps-dialog').classList.add('log-time-employee-dialog');
	}

	async init()
	{
		let employee_id = this.bindings.employee_id;
		let company_id = await Utils.current_user_company_id(employee_id);
		this.viewModel.company_id(company_id);
		
		// Disable the select dropdown if there is an log_time_employee id 
		if (this.bindings.log_time_employee != this.bindings.employee_id)
			this.viewModel.selected_employee(true);
	
		//get projects
		let res = await Grape.fetches.getJSON("/api/record", {
			table: "v_projects",
			schema: "savanna",
			filter: [{ value: company_id, operand: "=", field: "company_id" }],
		});

		//set bindings
		if (res?.records)
		{
			for (let i = 0; i < res.records.length; i++)
			{
				const record = res.records[i];
				const userDescription = record.user_description || "None";
				record.task_description = `${record.task_description} (${userDescription})`;
			}
			this.viewModel.projects(res.records);
		}

		await this.get_transaction_types();

		//edit mode
		if (this.bindings && this.bindings.task_time_id)
		{
			this.viewModel.task_time_id(this.bindings.task_time_id);
			this.viewModel.description(this.bindings.description || "");
			this.viewModel.task_id(this.bindings.project_task_id || null);
			this.viewModel.start_time(this.bindings.start_time);
			this.viewModel.end_time(this.bindings.end_time);
			this.viewModel.rejection_reason(this.bindings.rejection_reason || null);
			this.viewModel.total_hours(this.bindings.total_hours || 0);
			this.viewModel.transaction_type_id(this.bindings.id || null);
			this.viewModel.lunch_start(this.bindings.lunch_start || null);
			this.viewModel.lunch_end(this.bindings.lunch_end || null);
			
			//view only
			if (this.bindings.view_only)
				this.viewModel.view_only(true);

			//resubmit
			if (this.bindings.resubmit)
			{
				this.viewModel.resubmit(true);
				this.viewModel.task_time_id(null);
				this.viewModel.rejected_id(this.bindings.task_time_id);
			}

			if (this.viewModel.lunch_start())
				this.viewModel.include_lunch(true);
		}

		this.updateData();

		try
		{
			//get approval structure
			let res = await Grape.fetches.postJSON("/time_management/get_approval_route",
				{
					employee_id: this.bindings.employee_id,
					task_time_id: this.viewModel.task_time_id(),
				}
			);

			if (res.approvers)
				this.viewModel.approval_route(res.approvers);
			else
				this.viewModel.approval_route(null);
		}
		catch (error)
		{
			Grape.alerts.alert(
				{
					type: 'error',
					title: 'Error',
					message: tr('Could not load approval structure.' + error.message)
				}
			);
		}

		console.log('select_individual',this.viewModel.selected_user )
		if (this.viewModel.selected_user())
		{
			let res_leave = await Grape.fetches.getJSON('/leave/' +
				this.viewModel.selected_user() +
				'/summary/2000-01-01/' +
				this.viewModel.summary_filter_earned_end(), {}
			);
		
			if (res_leave.status !== 'ERROR')
				this.viewModel.leave_summary(ko.mapping.fromJS(res_leave));
		}
		
			await this.load_calendar_colors();
			await this.load_holidays();
			await this.viewModel.load_events();
		
			this.viewModel.initialize_datepickers();
			this.add_custom_calendar_css();
	};

	async updateData ()
	{
		let res = await Grape.fetches.postJSON("/time_management/get_time_logged_employee",
			{
				employee_id: this.viewModel.selected_user(),
				start_date: this.viewModel.from_filter(),
				end_date: this.viewModel.to_filter(),
			}
		);

		if (res.time_logged)
		{
			for (let i = 0; i < res.time_logged.length; i++)
			{
				res.time_logged[i].start_time = Utils.get_timestamp(new Date(res.time_logged[i].start_time));
				if (res.time_logged[i].end_time)
					res.time_logged[i].end_time = Utils.get_timestamp(new Date(res.time_logged[i].end_time));
			}
			this.viewModel.tasks_logged(res.time_logged);
		}
		else
			this.viewModel.tasks_logged([]);

		try
		{
			let users = await Grape.fetches.getJSON("/api/record",
				{
					table: "v_active_manager_employee",
					schema: "savanna",
					filter: [
						{
							value: this.bindings.employee_id,
							operand: "=",
							field: "manager_employee_id",
						}
					],
				}
			);
			this.viewModel.available_users(users.records);
		}
		catch (error)
		{
			Grape.alerts.alert(
				{
					type: 'error',
					title: 'Error',
					message: tr('Could not load employee managers.' + error.message)
				}
			);
		}

		if (this.bindings.log_time_employee)
		{
			let selected_employee = this.bindings.log_time_employee
			this.viewModel.selected_user(selected_employee);
		}
	};

	async validate_entries ()
	{
		let valid = true;
		let message = "";
		if (!this.viewModel.task_id() && !this.viewModel.project_name())
		{
			valid = false;
			message = tr("Please provide either a new task name or select an already existing task name");
		}
		else if (!this.viewModel.start_time())
		{
			valid = false;
			message = tr("Please select a valid start time");
		}
		else if (!this.viewModel.total_hours() || this.viewModel.total_hours() < 0)
		{
			valid = false;
			message = tr("Please select the total number of hours as a positive number");
		}

		if (valid == false)
			Grape.alerts.alert({type: "error", message: message, title: tr("Error", "Error")});
		
		return valid;
	};

	async validate_lunch_times ()
	{
		if (!this.viewModel.lunch_start() || !this.viewModel.lunch_end())
		{
			Grape.alerts.alert({type: "error", message: tr("Please enter start and end time for lunch"), title: tr("Error", "Error")});
			return false;
		}

		if (this.viewModel.lunch_start() >= this.viewModel.lunch_end())
		{
			Grape.alerts.alert({type: "error", message: tr("Start time of lunch has to be smaller than the end time"), title: tr("Error", "Error")});
			return false;
		}

		return true;
	};

	async isNotViewOnlyAndNotResubmit ()
	{
		return !this.viewModel.view_only() && !this.viewModel.resubmit();
	};

	async get_transaction_types ()
	{
		//get all the employees
		let filter = [];
		filter = [{
			value: this.viewModel.company_id(),
			operand: "=",
			field: "company_id",
		},];

		let res = await Grape.fetches.getJSON("/api/record", {
			table: "transaction_type_user",
			schema: "public",
			limit: 1000000,
			filter: filter,
		});

		if (res.records != null)
			this.viewModel.transaction_types(res.records);
	};

	async load_calendar_colors()
	{
		let res = await Grape.fetches.postJSON('/general/get_leave_color_combinations', {});
		generateCSScolorCombinations(res);
	}

	async load_holidays()
	{
		let holiday_res = await Grape.fetches.postJSON('/leave/get_holidays', {});	

		if (holiday_res?.get_holidays)
			this.viewModel.holidays(holiday_res.get_holidays);
		else
			this.viewModel.holidays.removeAll();
	}

	add_custom_calendar_css()
	{
		const style = document.createElement('style');
		style.textContent = `
			.log-time-employee-dialog .flatpickr-calendar.end-date-calendar { 
				left: -1em;
			}

			.log-time-employee-dialog .flatpickr-calendar.static.open {
				display: inline-grid;
			}

			.log-time-employee-dialog .dayContainer {
				height: 15.5em;
				min-width: 238px;
				max-width: 238px;
			}

			.log-time-employee-dialog .flatpickr-days {
				width: 238px !important;
			}

			.log-time-employee-dialog .flatpickr-day {
				font-weight: 400;
				width: 34px;
				-webkit-flex-basis: 34px;
				-ms-flex-preferred-size: 34px;
				flex-basis: 34px;
				max-width: 34px;
				height: 33px;
				line-height: 31px;
				display: inline-block;
				margin: 0;
				text-align: center;
				padding: 0;
			}

			.log-time-employee-dialog .flatpickr-calendar.open, 
			.log-time-employee-dialog .flatpickr-calendar.inline {
				opacity: 1;
				max-height: 640px;
				visibility: visible;
				height: 281px;
				width: 238px;
			}

			.log-time-employee-dialog .flatpickr-month {
				height: 34px;
				display: flex;
				align-items: center;
				padding: 4px 0;
			}

			.log-time-employee-dialog .flatpickr-current-month {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 101%;
				height: 35px;
				padding: 1;
				font-size: 15px;
			}

			.log-time-employee-dialog .flatpickr-current-month .cur-month {
				margin-right: 4px;
			}

			.log-time-employee-dialog .numInputWrapper {
				width: 54px;
				margin-right: 0.5em;
				margin-left: 0.5em;
				font-size: 11px;
			}

			.log-time-employee-dialog .flatpickr-monthDropdown-months {
				font-size: 17px;
				font-weight: 400;
				height: 22px;
				padding: 0 4px;
			}

			.log-time-employee-dialog .numInput.cur-year {
				font-size: 14px;
				height: 22px;
				padding: 0 4px;
			}

			.log-time-employee-dialog .flatpickr-weekdays {
				height: 28px;
				display: flex;
				align-items: center;
			}

			.log-time-employee-dialog .flatpickr-weekday {
				width: 34px;
				max-width: 34px;
				flex: 0 0 34px;
				margin: 0;
				text-align: center;
				font-size: 12px;
			}

			.log-time-employee-dialog #datepicker_start + .flatpickr-calendar {
				left: -1em;
			}

			.log-time-employee-dialog .flatpickr-months .flatpickr-prev-month,
			.log-time-employee-dialog .flatpickr-months .flatpickr-next-month {
				height: 34px;
				padding: 4px;
				display: flex;
				align-items: center;
				justify-content: center;
			}`;
		document.head.appendChild(style);

		// Apply the custom class to the end date picker
		if (this.viewModel.end_date_picker) 
			this.viewModel.end_date_picker.calendarContainer.classList.add('end-date-calendar');
	}
};

export default {
	name: "LogTimeEmployee",
	dialog_class: LogTimeEmployeePage,
	template: template,
	template_filename: "translation/dialogs/log_time_employee",
	provider: 'ps'
};
